import React from "react";
import clsx from "clsx";
import { ArrowSortedDownIcon, ArrowSortedUpIcon, ArrowUnsortedIcon } from "assets/svgs";
import { Theme } from "evcharging/app/themes";
import { css } from "@emotion/css";
import useTheme from "evcharging/hooks/useTheme";
import useI18n from "evcharging/hooks/useI18n";

interface RatesSortableCellProps {
  column: {
    name: string;
    sortable: boolean;
    property: string;
  };
  sort: string;
  onSort(sort: string): void;
  className?: string;
}

const getIconByOrderBy = (orderBy: string) => {
  switch (orderBy) {
    case 'asc':
      return <ArrowSortedUpIcon />;
    case 'desc':
      return <ArrowSortedDownIcon />;
    default:
      return <ArrowUnsortedIcon />;
  }
};

const calcNextOrderBy = (prev: string) => {
  switch (prev) {
    case 'asc':
      return 'desc';
    case 'desc':
      return undefined;
    default:
      return 'asc';
  }
};

const RatesSortableCell: React.FC<RatesSortableCellProps> = (props) => {
  const { onSort, column, sort, className = '' } = props;
  const { sortable, property, name } = column;
  const [sortBy, orderBy] = sort.split(',');
  const isCurrent = sortBy === property;
  const theme = useTheme();
  const classes = createStyles(theme);

  const handleClick = () => {
    if (sortable) {
      const nextOrderBy = calcNextOrderBy(isCurrent ? orderBy : '');
      onSort(nextOrderBy ? `${property},${nextOrderBy}` : '');
    }
  };

  return (
    <th
      className={clsx(classes.root, classes.sortable, className)}
      onClick={handleClick}
      id={`sort-${property}`}
    >
      <div className={classes.inner}>
        {name}
        {sortable && (
          <>
            &nbsp;
            {getIconByOrderBy(isCurrent ? orderBy : '')}
          </>
        )}
      </div>
    </th>
  );
};

const createStyles = (theme: Theme) => ({
  root: css({
    padding: theme.spacing(2, 2, 2, 2),
    color: '#93979B',
    fontSize: theme.spacing(1.625),
    fontWeight: 600,
    borderBottom: 'none',
  }),
  sortable: css({
    cursor: 'pointer',
  }),
  inner: css({
    display: 'flex',
    alignItems: 'center',
  }),
});

export default RatesSortableCell;
